import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "licenta-theme"

export default class extends Controller {
  static targets = ["toggle", "label"]

  connect() {
    this.boundTurboLoad = this.#syncUi.bind(this)
    document.addEventListener("turbo:load", this.boundTurboLoad)
    this.#applyFromStorage()
    this.#syncUi()
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.boundTurboLoad)
  }

  toggle() {
    const nextDark = !document.documentElement.classList.contains("dark")
    this.#setMode(nextDark ? "dark" : "light")
  }

  #storedDark() {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === "dark") return true
    if (stored === "light") return false
    if (stored === "system") return window.matchMedia("(prefers-color-scheme: dark)").matches
    return window.matchMedia("(prefers-color-scheme: dark)").matches
  }

  #setMode(mode) {
    const dark = mode === "dark"
    localStorage.setItem(STORAGE_KEY, dark ? "dark" : "light")
    document.documentElement.classList.toggle("dark", dark)
    const meta = document.querySelector('meta[name="theme-color"]')
    if (meta) meta.content = dark ? "#09090b" : "#f8fafc"
    this.#syncUi()
  }

  #applyFromStorage() {
    const dark = this.#storedDark()
    document.documentElement.classList.toggle("dark", dark)
    const meta = document.querySelector('meta[name="theme-color"]')
    if (meta) meta.content = dark ? "#09090b" : "#f8fafc"
  }

  #syncUi() {
    const dark = document.documentElement.classList.contains("dark")
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-checked", dark ? "true" : "false")
      this.toggleTarget.dataset.dark = dark ? "true" : "false"
    }
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = dark ? "Dark mode" : "Light mode"
    }
  }
}
